import { createAction } from '@reduxjs/toolkit';

export type ContextLinkClickPayload = {
  linkText: string;
  section: string;
  element: string;
};

export const analyzeLogout = createAction('analyzeLogout');

export const analyzeContextLinkClick = createAction<ContextLinkClickPayload>('analyzeContextLinkClick');
